"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var material_1 = require("@angular/material");
var idm_um_role_client_js_1 = require("@synisys/idm-um-role-client-js");
var operators_1 = require("rxjs/operators");
var Observable_1 = require("rxjs/Observable");
var Subject_1 = require("rxjs/Subject");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
require("./wf-process-permissions.component.scss");
var wf_process_permissions_configs_provider_1 = require("./service/wf-process-permissions-configs.provider");
var WfProcessPermissionsComponent = /** @class */ (function () {
    function WfProcessPermissionsComponent(roleService, kbService, sessionDataProvider, processConfigProvider) {
        this.roleService = roleService;
        this.kbService = kbService;
        this.sessionDataProvider = sessionDataProvider;
        this.processConfigProvider = processConfigProvider;
        this.EDIT_MODE = 1;
        this.VIEW_MODE = 2;
        this.destroy$ = new Subject_1.Subject();
        this._displayedColumns = ['category', 'roles', 'actions'];
    }
    WfProcessPermissionsComponent.prototype.ngOnInit = function () {
        var _this = this;
        var processes$ = this.processConfigProvider.getConfigurations();
        var roles$ = this.getRoles();
        var categories$ = this.kbService.getMainEntityMetaCategories();
        var language$ = this.sessionDataProvider.getCurrentLanguage();
        Observable_1.Observable.zip(roles$, categories$, language$, processes$).pipe(operators_1.takeUntil(this.destroy$)).subscribe(function (data) {
            var allRoles = data[0];
            var allCategories = data[1];
            var language = data[2];
            var processesConfigs = data[3];
            var processes = processesConfigs.map(function (processConfig) {
                var processRoles = (processConfig.roles && processConfig.roles.length) ? processConfig.roles : allRoles.map(function (role) { return role.id; });
                var processRolesName = processRoles.map(function (roleId) { return allRoles.find(function (role) { return role.id === roleId; }).properties['name']; }).join(', ');
                var processCategoryName = Array.from(allCategories.values())
                    .find(function (category) { return category.getMetaCategoryId().getSystemName() === processConfig.category; }).getDisplayNameMultilingual().getValue(language.getId());
                return {
                    categoryName: processCategoryName,
                    rolesName: processRolesName,
                    roles: processRoles,
                    category: processConfig.category,
                    firstClassifierField: processConfig.firstClassifierField,
                    firstClassifierLabel: processConfig.firstClassifierLabel,
                    secondClassifierField: processConfig.secondClassifierField,
                    secondClassifierLabel: processConfig.secondClassifierLabel,
                    saveAllButtonIsVisible: processConfig.saveAllButtonIsVisible
                };
            });
            _this._dataSource = new material_1.MatTableDataSource(processes);
            _this._initialized = true;
        });
    };
    WfProcessPermissionsComponent.prototype.ngOnDestroy = function () {
        this.destroy$.next(true);
        this.destroy$.complete();
    };
    WfProcessPermissionsComponent.prototype.editPermissions = function (process) {
        this._mode = this.EDIT_MODE;
        this._selectedProcess = process;
    };
    WfProcessPermissionsComponent.prototype.viewProcess = function (process) {
        this._mode = this.VIEW_MODE;
        this._selectedProcess = process;
    };
    WfProcessPermissionsComponent.prototype.getRoles = function () {
        var _this = this;
        return this.sessionDataProvider.getCurrentUserData().pipe(operators_1.switchMap(function (userData) {
            var criteria = {
                pagingCriteria: null,
                sortingCriteria: null,
                searchCriteria: { searchToken: null, languageId: null },
                organizationId: -1,
                currentUserId: userData.userId,
                userOrganizationId: null
            };
            return _this.roleService.getByCriteria(criteria);
        }), operators_1.map(function (roles) { return roles.data; }));
    };
    Object.defineProperty(WfProcessPermissionsComponent.prototype, "displayedColumns", {
        get: function () {
            return this._displayedColumns;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WfProcessPermissionsComponent.prototype, "dataSource", {
        get: function () {
            return this._dataSource;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WfProcessPermissionsComponent.prototype, "initialized", {
        get: function () {
            return this._initialized;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WfProcessPermissionsComponent.prototype, "selectedProcess", {
        get: function () {
            return this._selectedProcess;
        },
        set: function (value) {
            this._selectedProcess = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WfProcessPermissionsComponent.prototype, "mode", {
        get: function () {
            return this._mode;
        },
        enumerable: true,
        configurable: true
    });
    WfProcessPermissionsComponent = __decorate([
        core_1.Component({
            
            selector: 'ejustice-wf-process-permissions',
            template: require('./wf-process-permissions.component.html')
        }),
        __metadata("design:paramtypes", [idm_um_role_client_js_1.RoleService,
            idm_kb_service_client_js_1.KbService,
            idm_session_data_provider_api_js_1.SessionDataProvider,
            wf_process_permissions_configs_provider_1.WfProcessPermissionsConfigsProvider])
    ], WfProcessPermissionsComponent);
    return WfProcessPermissionsComponent;
}());
exports.WfProcessPermissionsComponent = WfProcessPermissionsComponent;
//# sourceMappingURL=wf-process-permissions.component.js.map